import React, { ReactElement } from 'react';
import { Circle } from 'rc-progress';
import styled, { useTheme } from 'styled-components';

const ProgressWrapper = styled('div')`
  max-width: 32px;
  flex-shrink: 0;
  position: relative;
  margin-top: 10px;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 200px;
      height: 200px;
      
      ${mediaQueries.desktop} {
        width: 32px;
        height: 32px;
      }
    `;
  }}
`;

interface ProgressProps {
  percent: number;
}

const Progress = ({ percent = 0 }: ProgressProps): ReactElement => {
  const { colors } = useTheme();

  let percentage = percent;
  if (percentage < 0) percentage = 0;
  if (percentage > 100) percentage = 100;

  return (
    <ProgressWrapper>
      <Circle
        style={{ width: 32 }}
        percent={percent}
        gapDegree={0}
        gapPosition="top"
        strokeWidth={19}
        trailWidth={19}
        strokeLinecap="square"
        strokeColor={[colors.primary_400, colors.gray_200]}
        trailColor={colors.gray_600}
        transition=""
      />
    </ProgressWrapper>
  );
};

export default Progress;
